import antdRS from "antd/es/locale/sr_RS";
import bsMsg from "../locales/bs_BS.json";

const BsLang = {
    antd: antdRS,
    locale: "bs-BS",
    messages: {
        ...bsMsg,
    },
};
export default BsLang;
